export default __webpack_public_path__ + "static/media/newLUChead.234d17c6.svg";